module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Kategorien","noCategories":"Keine Kategorien","addCategory":"Kategorie hinzufügen","editCategories":"Kategorien bearbeiten"}}')
  delete Component.options._Ctor
}
